jQuery(function(){FastClick.attach(document.body)});